import Model, { AsyncHasMany, attr, hasMany } from '@ember-data/model';
import { uiTranslated } from 'admin-panel/utils/model';

import type { TranslatedField } from 'admin-panel/constants/types';
import type GenreModel from 'admin-panel/models/genre';
import type LocaleModel from 'admin-panel/models/locale';

export default class RoomControlTvChannelModel extends Model {
  @hasMany('genre')
  declare genres: AsyncHasMany<GenreModel>;

  @hasMany('locale')
  declare locales: AsyncHasMany<LocaleModel>;

  @attr
  declare titleTranslations: TranslatedField;

  @uiTranslated
  declare title: string;

  @attr
  declare abbreviation: string;

  @attr
  declare logoUrl: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'room-control/tv-channel': RoomControlTvChannelModel;
  }
}
